// src/components/SafetyTipsPage.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/DeleteAccount.css";
import Header from "./Header";
import Footer from "./Footer";

const SECTIONS = [
  {
    title: "Before you start a conversation",
    tips: [
      "Keep your last name, workplace, home address and daily routine out of your profile and early messages.",
      "Use photos that do not show your home, your car's plate or your children.",
      "Look for the verified badge. It means a Mabrook team member compared a live selfie with the profile photos.",
    ],
  },
  {
    title: "While you chat",
    tips: [
      "Stay in the Mabrook messaging for the first conversations. Moving quickly to WhatsApp, Instagram or a phone number is a common sign of a fake profile.",
      "Never send money, gift cards, bank details or identity documents to another member, whatever the reason given. Asking for money is forbidden on Mabrook and leads to permanent exclusion.",
      "Be careful with anyone who declares strong feelings very quickly, avoids video calls, or always has an emergency.",
      "Do not share intimate photos or videos. They can be used against you.",
    ],
  },
  {
    title: "Before meeting in person",
    tips: [
      "Have a video call first. A person who refuses one is probably not who they claim to be.",
      "Tell a family member or a friend who you are meeting, where and when. Share your live location with them.",
      "Choose a public place during the day: a café, a restaurant, a shopping centre. Never a private home or an isolated place for a first meeting.",
      "Arrange your own transport there and back. Do not depend on the other person to get home.",
    ],
  },
  {
    title: "During the meeting",
    tips: [
      "Keep your phone charged and with you.",
      "Keep your drink in sight at all times.",
      "If something feels wrong, leave. You do not owe anyone an explanation.",
      "Involving your families early is part of the Moroccan way of doing things, and it is also a protection.",
    ],
  },
  {
    title: "Recognise a scam",
    tips: [
      "A story that quickly turns to money: a medical emergency, a blocked bank account, a customs fee, an investment opportunity.",
      "A profile with very few photos, photos that look professional, or details that change from one conversation to the next.",
      "Pressure to decide fast, to keep the relationship secret, or to cut contact with your family.",
      "Someone who says they live abroad and needs money to come to Morocco.",
    ],
  },
  {
    title: "Report and block",
    tips: [
      "You can block any member at any time. Blocking is immediate and mutual.",
      "You can report a profile or a conversation from the app. Reports are confidential: the person reported never knows who reported them.",
      "Our team reviews every report. Fraud, fake profiles and money requests lead to permanent exclusion.",
      "In an emergency, contact the police (19) or the gendarmerie (177) before contacting us.",
    ],
  },
];

const SafetyTipsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="da-page">
        <div className="da-card">
          <div className="da-header">
            <span className="da-eyebrow">{t("Your safety")}</span>
            <h1 className="da-title">{t("Safety Tips")}</h1>
          </div>

          <p className="da-body">
            {t(
              "Mabrook verifies profiles and moderates reports, but we do not carry out background checks. These tips help you protect yourself, online and when you meet someone.",
            )}
          </p>

          {SECTIONS.map(({ title, tips }) => (
            <div key={title} className="da-warning">
              <strong>{t(title)}</strong>
              <ul>
                {tips.map((tip) => (
                  <li key={tip}>{t(tip)}</li>
                ))}
              </ul>
            </div>
          ))}

          <p className="da-footer">
            {t("To report a member or a conversation:")}{" "}
            <a href="mailto:report@mabrook.ma">report@mabrook.ma</a>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SafetyTipsPage;
